/**
 * Variable model
 */

import { CustomProperty, SetupCustomPropertyData } from './CustomProperty';

// Forward declaration
declare function ArrayCloneForDiff(arr: any[]): any[];

export class Variable {
    dNumType: number = 0;
    dMin: string = "";
    dMax: string = "";
    sString: string = "None";
    varname: string = "None";
    GroupName: string = "None";
    bEnforceRestrictions: boolean = false;
    dtDateTime: string = "";
    vartype: string = "";
    VarComment: string = "";
    VarArray: any[] | null = null;
    CustomProperties: CustomProperty[] = [];

    cloneForDiff(): {
        dNumType: number;
        sString: string;
        dtDateTime: string;
        VarArray: any[] | null;
        CustomProperties: any[];
    } {
        return {
            dNumType: this.dNumType,
            sString: this.sString,
            dtDateTime: this.dtDateTime,
            VarArray: this.VarArray === null ? null : ((window as any).ArrayCloneForDiff?.(this.VarArray) || this.VarArray.slice()),
            CustomProperties: (window as any).ArrayCloneForDiff?.(this.CustomProperties) || this.CustomProperties.slice(),
        };
    }
}

export function SetupVariableData(RoomData: any[]): Variable {
    const TheVariable = new Variable();
    TheVariable.dNumType = RoomData[0];
    TheVariable.dMin = RoomData[1];
    TheVariable.dMax = RoomData[2];
    TheVariable.sString = RoomData[3];
    TheVariable.varname = RoomData[4];
    TheVariable.GroupName = RoomData[5];
    TheVariable.bEnforceRestrictions = RoomData[6];
    TheVariable.dtDateTime = RoomData[7];
    TheVariable.vartype = RoomData[8];
    TheVariable.VarComment = RoomData[9];
    TheVariable.VarArray = RoomData[10];
    for (let i = 0; i < RoomData[11].length; i++) {
        TheVariable.CustomProperties.push(SetupCustomPropertyData(RoomData[11][i]));
    }
    return TheVariable;
}
